import InstructionForm from '../components/instructions/Form';
import List from '../components/instructions/List';
import { connect } from "react-redux";
import { fetchFormValues, addInstruction, editInstruction, fetchMyInstructions, updateOrder, deleteInstruction } from "../store/actions/instructions";
import withAuth from '../hocs/withAuth';
import { saveFile } from '../store/actions/files';
import { showLoader, hideLoader } from '../store/actions/loader';

function mapStateToProps(state, ownProps) {
  var editId = null;
  let userType = ownProps.user && ownProps.user.type;
  if (userType.includes('brand') || userType.includes('corporate')) userType = 'trainer';
  if (ownProps.match) editId = ownProps.match.params.id;
  if (ownProps.editId) editId = ownProps.editId;
  if (ownProps.workoutId) editId = ownProps.workoutId;
  return {
    errors: state.errors,
    user: state.currentUser.user,
    instructions: state.instructions[userType],
    cats: state.instructionCats,
    editId: editId,
    path: ownProps.match ? ownProps.match.path : null
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchList: (query) => {
        return dispatch(fetchMyInstructions(query));
    },
    fetchFormFilterData: () => {
      return dispatch(fetchFormValues(ownProps.user._id));
    },
    fetch: (userId, editId) => {
      dispatch(fetchMyInstructions(userId));
      return dispatch(fetchFormValues(userId));
    },
    addInstruction: (formData, user) => {

      let userType = ownProps.user.type;
      if (userType && userType.includes('trainer')) {
        userType = 'trainer';
      }
      if (userType && userType.includes('brand')) {
        userType = 'brand';
      }
      if (userType && userType.includes('corporate')) {
        userType = 'brand';
      }
      return dispatch(addInstruction({
        ...formData,
        creatorId: ownProps.user._id,
        creatorType: userType
      }, user));
    },
    deleteInstruction: (id) => {
      return dispatch(deleteInstruction(id));
    },
    updateOrder: (instruction) => {
      return dispatch(updateOrder(instruction));
    },
    edit: (editId, exercise, user) => {
      return dispatch(editInstruction(editId, exercise, user));
    },
    addFile: (fileMeta) => {
      return dispatch(saveFile(fileMeta));
    },
    showLoader: () => {
      return dispatch(showLoader());
    },
    hideLoader: () => {
      return dispatch(hideLoader());
    },
  }
}
export const EditInstruction = withAuth(connect(mapStateToProps, mapDispatchToProps)(InstructionForm))
export const CreateInstruction = withAuth(connect(mapStateToProps, mapDispatchToProps)(InstructionForm))
export default withAuth(connect(mapStateToProps, mapDispatchToProps)(List))



// WEBPACK FOOTER //
// ./src/containers/Instructions.js